import * as React from 'react';
import * as ReactDOM from 'react-dom';

import PresentationTemplateRoot from './components/rootComponents/PresentationTemplateRoot';

declare var Raven: any;
declare var window: any;

Raven.context(() => {
    ReactDOM.render(
        <PresentationTemplateRoot
            categories={ window.props.categories }
            templates={ window.props.templates }
            isAuthenticated={ window.props.isAuthenticated }
            preloadTemplatePreviewVideos={ window.props.preloadPreviewVideos }
            categoryString={ window.props.categoryString }
            useThisTemplateCTA={ window.props.useThisTemplateCTA }
            getStartedCTA={ window.props.getStartedCTA }
            relatedTemplatesString={ window.props.relatedTemplatesString }
            usePARF={ window.props.usePARF }
        />,
        document.getElementById('app'),
    );
});



// WEBPACK FOOTER //
// ./assets/js/TemplatesIndex.tsx